import React, { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { APP_AD_SCRIPT_PART_URL, APP_IRE_PLAYER_WIDGET_ORIGIN } from '@/modules/common/constants/envs';

import { RootContainers } from '@/modules/common/helpers';
import * as commonSelectors from '@/modules/common/redux/selectors/common';

function AdProvider({ children }: { children: ReactNode }) {
  const ad = useSelector(commonSelectors.adSelector);
  const adHubId = useSelector(commonSelectors.adHubIdSelector);
  const adWidgetId = useSelector(commonSelectors.adWidgetIdSelector);

  useEffect(() => {
    let adTag: HTMLScriptElement | undefined;

    if (ad) {
      adTag = document.createElement('script');
      adTag.src = `https://${APP_IRE_PLAYER_WIDGET_ORIGIN}/${APP_AD_SCRIPT_PART_URL}`;
      adTag.async = true;
      adTag.setAttribute('data-widgetname', adWidgetId);
      adTag.setAttribute('data-pubname', adHubId);
      adTag.setAttribute('data-watch', 'true');

      RootContainers.getRootContainer().appendChild(adTag);
    }

    return () => {
      adTag?.remove();
    };
  }, [ad]);

  return <>{children}</>;
}

export default AdProvider;
